export enum CoordinationTransitionStatusTextEnum {
    REQ_UNKNOWN = 'Unknown',
    REQ_CREATE = 'Create',
    REQ_REMOVE = 'Remove',
    REQ_ACCEPTANCE = 'Accept',
    REQ_REVIEW = 'Review',
    REQ_APPROVAL = 'Approve',
    REQ_COORDINATE = 'Coordinate',
    REQ_ACTIVATE = 'Activate',
    REQ_DEACTIVATE = 'Deactivate',
    REQ_COMPLETE = 'Complete',
    REQ_FINISH = 'Finish',
    REQ_CANCEL = 'Cancel',
    ACK_CANCEL = 'Acknowledge cancel',
    REQ_SUSPEND = 'Suspend',
    ACK_SUSPEND = 'Acknowledge suspend',
    REQ_UNSUSPEND = 'Unsuspend',
    REQ_REJECT = 'Reject',
}